<div>
  <div class="title-container-print-mode print-only" *ngIf="order$ | async as order">
    <h1>
      {{ order.orderId }}
    </h1>
    <div *ngIf="statusBadge">
      <i>{{ 'LIB_ORDERS.COMMON.LABELS.STATUS' | translate }}: {{ statusBadge.text }}</i>
    </div>
  </div>
  <ng-container *ngIf="(loading$ | async) === false; else loading">
    <ng-container *ngIf="order$ | async as order">
      <orders-edit-order
        #editOrder
        [order]="order$ | async"
        [business]="business$ | async"
        [users]="users$ | async"
        [productIds]="productIds$ | async"
        [fileUploadUrl]="fileUploadUrl"
        [hideNotesSections]="hideNotesSections"
        [hideTagsSection]="hideTagsSection"
        [hideAttachmentsSection]="hideAttachmentsSection"
        [hideOrderFormSaveButton]="hideOrderFormSaveButton"
        (refreshOrderDetails)="refreshOrderDetails()"
      ></orders-edit-order>
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <mat-spinner [diameter]="30"></mat-spinner>
  </ng-template>
</div>
